import jsLogger from "js-logger";

jsLogger.useDefaults({
  formatter(messages) {
    messages.unshift(new Date().toTimeString().split(" ")[0]);
  },
});

export default jsLogger;
